module.exports = require("lunr");